export enum ModuleUrl {
  RUT_VALIDATION = "",
  CODE_VALIDATION = "code-validation",
  SUCCESS = "success",
  PASSWORD_CREATION = "passsword-creation",
  ERROR = "error"
}
